import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-investimenti-beni-strumentali',
    templateUrl: './investimenti-beni-strumentali.component.html',
    standalone: false
})
export class InvestimentiBeniStrumentaliComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Finanziamenti acquisto macchinari e attrezzature: Nuova Sabatini e crediti d’imposta Industria 4.0. Contributi a fondo perduto e prestiti agevolati per PMI";

        this.seoService.updateSeo({
            titleSeo: "Bandi Investimenti & Beni Strumentali – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string) {
        this.router.navigate([route])
    }

}
